{
  "autoSignIn": true,
  "popupForLogin": false,
  "cacheLocation": "localStorage",
  "instance": "https://login.microsoftonline.com/",
  "tenantId": "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  "clientId": "5ad55f75-e4d9-4d9d-a658-47c57fe45a28",
  "redirectUri": "https://expacg-test.azure.chevron.com",
  "oidcScopes": [
    "openid",
    "profile",
    "email",
    "offline_access"
  ],
  "graphScopes": [
    "User.Read",
    "User.Read.All"
  ]
}
